import { useSystemConfigStore } from '/@/store/modules/systemConfig';

export const fontSizeMixin = {
  onShow() {
    // #ifdef APP-PLUS || MP-WEIXIN
    const systemConfigStore = useSystemConfigStore();
    const currentPage = getCurrentPages().pop();
    if (currentPage && typeof currentPage.$getAppWebview === 'function') {
      const pageEl = currentPage.$getAppWebview();
      if (pageEl) {
        pageEl.setStyle({
          fontSize: `${systemConfigStore.appFontSize}px`
        } as any);
        pageEl.evalJS(`
          document.documentElement.style.setProperty('--app-font-size', '${systemConfigStore.appFontSize}px');
        `);
      }
    }
    // #endif
  }
}; 